<div class="guest-access" [ngClass]="{ 'desktop': view.Desktop, 'mobile': view.Mobile }">
    <div *ngIf="status === 'LOADING'" class="guest-access__panel" uppDataid="guestaccess-loading">
        <ion-spinner name="crescent"></ion-spinner>
        <p>{{ tr('@guest_access_loading') }}</p>
    </div>

    <div *ngIf="status === 'ERROR'" class="guest-access__panel" uppDataid="guestaccess-error">
        <p>{{ tr('@guest_access_error') }}</p>
    </div>

    <div *ngIf="status === 'READY'" class="guest-access__panel" uppDataid="guestaccess-ready">
        <p>{{ tr('@guest_access_ready') }}</p>
    </div>
</div>
